import {
    Component,
    EventEmitter,
    Input,
    Output,
    OnDestroy,
} from '@angular/core';
import { IConfirmationInput } from './confirmation.interface';

@Component({
    selector: 'app-confirmation',
    templateUrl: './confirmation.component.html',
    styleUrls: ['./confirmation.component.scss'],
})
export class ConfirmationComponent implements OnDestroy {
    @Input() data: IConfirmationInput;
    @Output() complete = new EventEmitter();
    showFooterPopup:boolean=true;

    ngOnInit() {

        if (typeof this.data.hideFooter !== 'undefined') {
            this.showFooterPopup = false;
        } else{
            this.showFooterPopup = true;
        }
    }

    ngOnDestroy(): void {
        this.data.singleButton = false;
    }

    confirm() {
        this.complete.emit({ action: true });
    }
    cancel() {
        this.complete.emit({ action: false });
    }

    close() {
        this.data.open = false;
    }
}
